document.addEventListener("DOMContentLoaded", function () {
    var button = document.getElementById('toggleMenu');
    var container = document.getElementById('headerNavMain');
    if (!button || !container)
        return;
    button.addEventListener('click', function () {
        container.classList.toggle('menuOpen');
    });
});
